import { render } from "./FormModule.vue?vue&type=template&id=63b12047"
import script from "./FormModule.vue?vue&type=script&lang=js"
export * from "./FormModule.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__